export default {"src":"https://fishbrain.com/_next/static/media/first_quarter.cca2c2d8.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};